export default __webpack_public_path__ + "static/media/PLE.e287e995.svg";